export const EDITOR_MODE = {
  edit: "EDIT",
  preview: "PREVIEW",
  split: "SPLIT",
} as const;

export type EditorMode = (typeof EDITOR_MODE)[keyof typeof EDITOR_MODE];

export const FIELD_LABEL = {
  description: "Short description",
  overview: "Full description",
} as const;

export const getDraftStorageKey = (
  packageId: string,
  property: keyof typeof FIELD_LABEL,
): string => `package-about:${packageId}:${property}`;

export const EDITOR_MODE_STORAGE_KEY = "package-about:mode";

export const isEditorMode = (value: string | null): value is EditorMode =>
  value === EDITOR_MODE.edit ||
  value === EDITOR_MODE.preview ||
  value === EDITOR_MODE.split;
